import React from 'react';
import { Table } from 'antd';
import type { ColumnsType, TableProps } from 'antd/es/table';

interface OrdersTableProps<T> {
  columns: ColumnsType<T>;
  dataSource: T[];
  loading?: boolean;
  pagination: TableProps<T>['pagination'];
  onChange?: TableProps<T>['onChange'];
  rowKey?: string;
  scroll?: TableProps<T>['scroll'];
  expandable?: TableProps<T>['expandable'];
  rowSelection?: TableProps<T>['rowSelection'];
  sticky?: TableProps<T>['sticky'];
  size?: TableProps<T>['size'];
}

function OrdersTable<T extends { id?: React.Key }>(props: OrdersTableProps<T>) {
  const {
    columns,
    dataSource,
    loading,
    pagination,
    onChange,
    rowKey = 'id',
    scroll = { x: 1500 },
    expandable,
    rowSelection,
    sticky = { offsetHeader: 0 },
    size = 'small',
  } = props;
  return (
    <Table<T>
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      size={size}
      scroll={scroll}
      expandable={expandable}
      rowSelection={rowSelection}
      pagination={pagination}
      onChange={onChange}
      rowKey={rowKey as any}
      sticky={sticky}
    />
  );
}

export default OrdersTable;
